<script setup lang="ts">
import imageUrl from '@/assets/login.svg'
import { RouterView,RouterLink } from 'vue-router'
import { makeCoreUrl } from "@/helpers/routing";
import { provide, ref } from 'vue'
import { UpdateShowTermsInjectionKey } from '@/features/auth/injections'

const showTerms = ref(true)

provide(UpdateShowTermsInjectionKey, (value: boolean) => { showTerms.value = value })
</script>

<template>
  <div class="d-flex justify-content-center align-items-center" :class="$style['wrapper']">
    <div class="text-center">
      <img :src="imageUrl" width="395" alt="" />
      <RouterView />
      <div v-if="showTerms" class="mt-4">
        By proceeding you acknowledge
        <br />
        and agree to Unifii's
        <a :href="makeCoreUrl(['TermsAndConditions', 'UserTermsAndConditionsView'])">terms of use</a>.
      </div>
      <div v-if="showTerms" :class="['mt-4', $style.emailCta]">
        Sign in with 
        <RouterLink
        :to="{ name: 'auth.login.email', query: $route.query }">email &amp; password
      </RouterLink>
        instead.
        <br />
        SolarAfrica Microsoft account, please sign in on this main screen.
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
.wrapper {
  min-height: calc(100vh - 50px);
}
.emailCta:has(:global(.router-link-active)) { display: none; }
</style>
